<div *ngIf="cardHeader != null" class="ph--5" taCardHeader>
  <div class="pt--4 pb--2 border--bottom">
    <ng-container
      [ngTemplateOutlet]="cardHeader.contentTemplate"
    ></ng-container>
  </div>
</div>

<div class="p--6"><ng-content></ng-content></div>
